import styled from "styled-components";
import { MEDIA_DESKTOP } from "../../../../../../hooks/useScreenOrientation";

export const FranchiseAreaFilterWrapper = styled.div<{ isApp: number | null }>`
  background: white;
  padding-left: 16px;
  padding-bottom: 8px;
  position: fixed;
  top: ${(p) => (p.isApp ? `${p.isApp + 40}px` : "40px")};
  width: 100%;
  display: flex;
  background: white;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  z-index: 11;
  @media ${MEDIA_DESKTOP} {
    gap: 20px;
  }

  .filter-list {
    margin-top: 20px;
    width: 100%;
    height: 30px;

    .swiper-slide {
      width: auto !important;

      &:last-child {
        margin-right: 32px;
      }
    }
  }

  .like-icon {
    width: 30px;
    height: 30px;
  }
`;

export const CardItemWrapper = styled.div<{ isSelected: boolean }>`
  padding: 0 12px;
  border-radius: 15px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid
    ${(p) => (p.isSelected ? "#6436E7" : "var(--Black-200, #B7B7B7)")};
  color: ${(p) => (p.isSelected ? "#fff" : "var(--Black-500, #202020)")};
  background: ${(p) => (p.isSelected ? "#6436E7" : "#fff")};
  font-family: Pretendard;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`;
